import React from "react";
import { RecentFits as RecentFitsApp } from "../apps/recentfits";
import { Layout } from "../components";

const RecentFits: React.FC = () => {
  return (
    <Layout title="Recent Fits">
      <RecentFitsApp />
    </Layout>
  );
};

export default RecentFits;
